module.exports = __webpack_public_path__ + "202408221624/img/img_example_work_120@2x.c1b21a61.png";